<template>
  <div id="library-page" :class="{'page': !modal && !modalFolder}">
    <div :class="{'mt-10': !modal && !modalFolder, 'mt-5': modal || modalFolder}">
      <div class="flex justify-between align-items-center">
        <div class="w-full">
          <h2 v-if="searched != null && searched != ''" class="intro-y text-lg font-medium">
            「{{ searched }}」的搜尋結果
          </h2>

          <div v-else-if="(modal == null || !modal) && (modalFolder == null || !modalFolder)" class="flex align-items-center overflow-x-auto directory-list">
            <h2 class="intro-y text-lg font-medium root">

              <router-link to="/library" v-if="$route.path !== '/library'">
                檔案櫃
              </router-link>
              <span v-else>檔案櫃</span>
            </h2>

            <span v-for="(item, key) in parentFolders" :key="key" class="flex align-items-center">
              <font-awesome-icon icon="fa-solid fa-chevron-right" class="ml-4 mr-4"/>

              <router-link :to="`/library/${item.item_code}`"
                class="intro-y text-lg font-medium"
                :title="`${item.item_name}`">
                {{ item.item_name }}
              </router-link>
            </span>

            <font-awesome-icon v-if="item != null" icon="fa-solid fa-chevron-right" class="ml-4 mr-4"/>

            <div class="intro-y text-lg font-medium" v-if="item != null">{{ item.item_name }}</div>

            <div v-if="!loading && mounted && (modal == null || !modal)" class="flex justify-center items-center action folder-action ml-2 relative">
              <button type="button" class="dropdown-toggle w-5 h-5 block" @click="folderAction = !folderAction" @focusout="folderAction = false">
                <font-awesome-icon icon="fa-solid fa-ellipsis-vertical"/>
              </button>

              <div class="fixed z-50">
                <div class="dropdown-menu w-40" :class="{'show': folderAction}">
                  <ul class="dropdown-content">
                    <li v-if="item != null && hasPermission('write', item)">
                      <button type="button" class="dropdown-item" @click.stop="openRenameModal(item)">
                        <font-awesome-icon icon="fa-solid fa-file-pen" class="fa-1x w-5 mr-2"/>
                        重新命名
                      </button>
                    </li>
                    <li v-if="checkPermission(permissions, 'site.media-library.manage') && checkPermission(permissions, 'site.media-library.permission')">
                      <button type="button" class="dropdown-item" @click.stop="openPermissionModal(item ?? 0)">
                        <font-awesome-icon icon="fa-solid fa-sliders" class="fa-1x w-5 mr-2"/>
                        設定權限
                      </button>
                    </li>
                    <li v-if="item != null && hasPermission('write', item)">
                      <button type="button" class="dropdown-item" @click.stop="onCreateShareCode(item)">
                        <font-awesome-icon icon="fa-solid fa-link" class="fa-1x w-5 mr-2"/>
                        分享連結
                      </button>
                    </li>
                    <li v-if="item != null && hasPermission('write', item)">
                      <button type="button" class="dropdown-item" @click.stop="openTagModal(item)">
                        <font-awesome-icon icon="fa-solid fa-tags" class="fa-1x w-5 mr-2"/>
                        管理標籤
                      </button>
                    </li>
                    <li v-if="!(item != null && hasPermission('write', item)) && !(checkPermission(permissions, 'site.media-library.manage') && checkPermission(permissions, 'site.media-library.permission'))">
                      沒有動作
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div v-else class="flex align-items-center overflow-x-auto directory-list px-4">
            <h2 class="intro-y text-lg font-medium root">

              <button @click="onChangeFolder()">
                檔案櫃
              </button>
            </h2>

            <span v-for="(item, key) in parentFolders" :key="key" class="flex align-items-center">
              <font-awesome-icon icon="fa-solid fa-chevron-right" class="ml-4 mr-4"/>

              <button @click="onChangeFolder(item.item_code)"
                class="intro-y text-lg font-medium"
                :title="`${item.item_name}`">
                {{ item.item_name }}
              </button>
            </span>

            <font-awesome-icon v-if="item != null" icon="fa-solid fa-chevron-right" class="ml-4 mr-4"/>

            <div class="intro-y text-lg font-medium" v-if="item != null">{{ item.item_name }}</div>
          </div>
        </div>

        <div class="flex flex-nowrap align-items-center px-4">
          <span v-if="modalFolder" v-show="loading" class=""><i data-loading-icon="oval" class="w-8 h-8"></i></span>
          <button v-if="!loading && modalFolder && (!currentSelectedItem || (item == null && currentSelectedItem.folder_id != 0) || (item != null && item.item_id != currentSelectedItem.folder_id && item.item_id != currentSelectedItem.item_id)) && (!modalFolderWriteOnly || hasPermission('write', item))" @click.stop="$emit('select', item)" class="btn btn-primary ml-2 whitespace-nowrap">選擇</button>
        </div>
      </div>
    </div>

    <div>
      <div class="box grid grid-cols-12 gap-6 mt-5 p-5">

        <div v-if="!modalFolder" class="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-start flex-col sm:flex-row md:items-center">
          <div v-if="!downloading && hasPermission('write', item)" class="flex flex-wrap sm:flex-nowrap items-center justify-end mr-2 mb-1 sm:mb-0">
            <button class="btn btn-primary shadow-md" @click="openUploadModal">上載</button>

            <button class="btn btn-primary shadow-md ml-2" @click="openCreateFolderModal">
              新增資料夾
            </button>
          </div>
          <div class="flex flex-wrap sm:flex-nowrap mt-1 sm:mt-0 items-center justify-end">
            <button v-if="!downloading && selectedItemIds.length < items.length && !modal" class="btn btn-secondary shadow-md mr-2" @click="selectAllItems">
              全選
            </button>

            <button v-if="!downloading && selectedItemIds.length > 0" class="btn btn-secondary shadow-md" @click="clearSelectedItems">
              清除選擇
            </button>

            <div v-if="!downloading && selectedItemIds.length > 0" class="flex justify-center items-center action ml-2">
              <button type="button" class="btn btn-primary shadow-md dropdown-toggle" @click="action = !action" @focusout="action = false">
                動作
              </button>
              <div class="relative">
                <div class="dropdown-menu w-40" :class="{'show': action}">
                  <ul class="dropdown-content">
                    <li v-if="checkAllSelectedItemsType('FILE') && checkAllSelectedItemsHavePermission('read')">
                      <button type="button" class="dropdown-item" @click.stop="onMultipleDownload()">
                        <font-awesome-icon icon="fa-solid fa-cloud-arrow-down" class="fa-1x w-5 mr-2"/>
                        下載
                      </button>
                    </li>
                    <li v-if="checkAllSelectedItemsHavePermission('write') && (modal == null || !modal)">
                      <button type="button" class="dropdown-item" @click="openMoveModal()">
                        <font-awesome-icon icon="fa-solid fa-up-down-left-right" class="fa-1x w-5 mr-2"/>
                        移動
                      </button>
                    </li>
                    <li v-if="checkPermission(permissions, 'site.media-library.permission') && checkAllSelectedItemsHavePermission('write') && (modal == null || !modal)">
                      <button type="button" class="dropdown-item" @click.stop="openItemsPermissionModal()">
                        <font-awesome-icon icon="fa-solid fa-sliders" class="fa-1x w-5 mr-2"/>
                        設定權限
                      </button>
                    </li>
                    <li v-if="checkAllSelectedItemsHavePermission('write') && (modal == null || !modal)">
                      <button type="button" class="dropdown-item" @click="openTagModal()">
                        <font-awesome-icon icon="fa-solid fa-tags" class="fa-1x w-5 mr-2"/>
                        管理標籤
                      </button>
                    </li>
                    <li v-if="(checkPermission(permissions, 'site.media-library.manage') || checkAllSelectedItemsAreOwner()) && checkAllSelectedItemsHavePermission('write') && !checkAllSelectedItemsAreHidden(false) && (modal == null || !modal)">
                      <button type="button" class="dropdown-item" @click="onVisible()">
                        <font-awesome-icon icon="fa-solid fa-eye" class="fa-1x w-5 mr-2"/>
                        發佈
                      </button>
                    </li>
                    <li v-if="(checkPermission(permissions, 'site.media-library.manage') || checkAllSelectedItemsAreOwner()) && checkAllSelectedItemsHavePermission('write') && !checkAllSelectedItemsAreHidden(true) && (modal == null || !modal)">
                      <button type="button" class="dropdown-item" @click="onInvisible()">
                        <font-awesome-icon icon="fa-solid fa-eye-slash" class="fa-1x w-5 mr-2"/>
                        取出
                      </button>
                    </li>
                    <li v-if="checkAllSelectedItemsHavePermission('delete') && (modal == null || !modal)">
                      <button type="button" class="dropdown-item" @click.stop="openDeleteModal()">
                        <font-awesome-icon icon="fa-solid fa-trash" class="fa-1x w-5 mr-2"/>
                        刪除
                      </button>
                    </li>
                    <li v-if="!(((checkAllSelectedItemsHavePermission('read') && checkAllSelectedItemsType('FILE')) || (checkAllSelectedItemsHavePermission('write') && ((checkPermission(permissions, ['site.media-library.permission'])) || (checkPermission(permissions, ['site.media-library.manage']) || checkAllSelectedItemsAreOwner()))) || checkAllSelectedItemsHavePermission('delete')) && (modal == null || !modal))">
                      沒有動作
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <span v-show="downloading"><i data-loading-icon="oval" class="w-8 h-8"></i></span>
          </div>

          <div class="hidden md:block mx-auto text-slate-500">正在顯示 {{ items.length }} 個檔案</div>

          <div v-if="!loading" class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0 flex">
            <div class="mr-2 flex-basis-50 sm:flex-basis-0 sm:w-auto">
              <select id="tag-filter" v-model="tag" class="form-select w-auto" aria-label="關鍵字">
                <option value="">--- 關鍵字 ---</option>
                <option v-for="(item, key) in levelTags" :key="key" :value="item.tag_name_with_level">{{ item.tag_name_with_level.replaceAll(' ', '&nbsp;') }}</option>
              </select>
            </div>

            <div class="w-56 relative text-slate-500 ml-2">
              <input v-model="searchInput" type="text" class="form-control sm:w-56 pr-10" placeholder="搜尋" @keyup.enter="clickSearch">
              <button class="absolute my-auto w-4 h-4 mr-3 right-0 inset-y-0" type="button" @click="clickSearch"><font-awesome-icon icon="fa-solid fa-magnifying-glass" /></button>
            </div>
          </div>
          <div v-show="loading" class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0 flex">
            <span><i data-loading-icon="oval" class="w-8 h-8"></i></span>
          </div>
        </div>

        <!-- BEGIN: Data List -->
        <div class="intro-y col-span-12">
          <div class="overflow-auto min-h-screen">
            <table class="table table-striped">
            <thead>
            <tr>
              <th v-if="!modal && !modalFolder" class="text-center whitespace-nowrap">選取</th>
              <th class="text-center whitespace-nowrap"><span v-if="search !== ''">類型</span><order-button v-else title="類型" column="file_format_id" :order-by.sync="orderBy" :order.sync="order"></order-button></th>
              <th class="whitespace-nowrap w-1/2"><span v-if="search !== ''">名稱</span><order-button v-else title="名稱" column="item_name" :order-by.sync="orderBy" :order.sync="order"></order-button></th>
              <th class="text-center whitespace-nowrap"></th>
              <th class="library-optional-col whitespace-nowrap"><span v-if="search !== ''">建立日期</span><order-button v-else title="建立日期" column="created_at" :order-by.sync="orderBy" :order.sync="order"></order-button></th>
              <th class="whitespace-nowrap"><span v-if="search !== ''">上次修改日期</span><order-button v-else title="上次修改日期" column="updated_at" :order-by.sync="orderBy" :order.sync="order"></order-button></th>
              <th v-if="!modal && !modalFolder" class="library-optional-col whitespace-nowrap"><span v-if="search !== ''">版本</span><order-button v-else title="版本" column="file_versions_count" :order-by.sync="orderBy" :order.sync="order"></order-button></th>
              <th v-if="!modalFolder" class="library-optional-col whitespace-nowrap"><span v-if="search !== ''">檔案大小</span><order-button v-else title="檔案大小" column="file_size" :order-by.sync="orderBy" :order.sync="order"></order-button></th>
            </tr>
            </thead>

            <tbody>
            <tr class="" v-for="(item, key) in items" :key="key"
             :class="{'invisible': item.is_hidden, 'invisible-from-parent': item.isHiddenFromAll}">
              <td v-if="!modal && !modalFolder" class="text-center" @click="onSelect(item)"><input class="form-check-input border border-slate-500" type="checkbox" :value="item.item_id" v-model="selectedItemIds"></td>
              <td @click="onOpen(item)" class="text-center column-item-icon">
                <div class="item-icon bg-contain"
                     :class="{'folder': item.item_type === 'DIRECTORY', 'file': item.item_type === 'FILE'}"><span
                  v-if="item.item_type === 'FILE'">{{ getExtension(item) }}</span></div>
              </td>
              <td @click="onOpen(item)" class="w-1/2 text-break">
                {{ item.item_name ?? '-' }}
              </td>
              <td class="table-report__action">
                <div class="flex justify-end items-center action relative" @focusout="onUnselect">
                  <button v-if="!modalFolder && !hasNoPermission(item)" type="button" class="dropdown-toggle w-5 h-5 block" @click="onClick(item)" :tabindex="key">
                    <font-awesome-icon icon="fa-solid fa-ellipsis-vertical"/>
                  </button>

                  <div v-if="!modalFolder" class="fixed z-10">
                    <div class="dropdown-menu w-40" :class="{'show': item.item_id === currentItemId}">
                      <ul class="dropdown-content">
                        <li v-if="item.item_type === 'FILE' && isViewable(item) && hasPermission('read', item)">
                          <button type="button" class="dropdown-item" @click="onOpen(item)">
                            <font-awesome-icon icon="fa-solid fa-eye" class="fa-1x w-5 mr-2"/>
                            檢視
                          </button>
                        </li>
                        <li v-if="item.item_type === 'FILE' && hasPermission('read', item)">
                          <button type="button" class="dropdown-item" @click="onDownload(item, item.item_name)">
                            <font-awesome-icon icon="fa-solid fa-cloud-arrow-down" class="fa-1x w-5 mr-2"/>
                            下載
                          </button>
                        </li>
                        <li v-if="item.item_type === 'DIRECTORY' && hasPermission('read', item)">
                          <button type="button" class="dropdown-item" @click="onOpen(item)">
                            <font-awesome-icon icon="fa-solid fa-folder-open" class="fa-1x w-5 mr-2"/>
                            開啟
                          </button>
                        </li>
                        <li v-if="hasPermission('write', item) && (modal == null || !modal)">
                          <button type="button" class="dropdown-item" @click="openRenameModal(item)">
                            <font-awesome-icon icon="fa-solid fa-file-pen" class="fa-1x w-5 mr-2"/>
                            重新命名
                          </button>
                        </li>
                        <li v-if="hasPermission('write', item) && (modal == null || !modal)">
                          <button type="button" class="dropdown-item" @click="openMoveModal(item)">
                            <font-awesome-icon icon="fa-solid fa-up-down-left-right" class="fa-1x w-5 mr-2"/>
                            移動
                          </button>
                        </li>
                        <li v-if="hasPermission('write', item) && checkPermission(permissions, 'site.media-library.permission') && (modal == null || !modal)">
                          <button type="button" class="dropdown-item" @click="openPermissionModal(item)">
                            <font-awesome-icon icon="fa-solid fa-sliders" class="fa-1x w-5 mr-2"/>
                            設定權限
                          </button>
                        </li>
                        <li v-if="(modal == null || !modal) && hasPermission('write', item)">
                          <button type="button" class="dropdown-item" @click="onCreateShareCode(item)">
                            <font-awesome-icon icon="fa-solid fa-link" class="fa-1x w-5 mr-2"/>
                            分享連結
                          </button>
                        </li>
                        <li v-if="item.item_type === 'FILE' && hasPermission('write', item) && (modal == null || !modal)">
                          <button type="button" class="dropdown-item" @click="openVersionModal(item)">
                            <font-awesome-icon icon="fa-solid fa-code-fork" class="fa-1x w-5 mr-2"/>
                            檢視版本
                          </button>
                        </li>
                        <li v-if="hasPermission('write', item) && (modal == null || !modal)">
                          <button type="button" class="dropdown-item" @click="openTagModal(item)">
                            <font-awesome-icon icon="fa-solid fa-tags" class="fa-1x w-5 mr-2"/>
                            管理標籤
                          </button>
                        </li>
                        <li v-if="hasPermission('write', item) && (checkPermission(permissions, 'site.media-library.manage') || item.user_id == profile.user_id) && item.is_hidden && (modal == null || !modal)">
                          <button type="button" class="dropdown-item" @click="onVisible(item)">
                            <font-awesome-icon icon="fa-solid fa-eye" class="fa-1x w-5 mr-2"/>
                            發佈
                          </button>
                        </li>
                        <li v-if="hasPermission('write', item) && (checkPermission(permissions, 'site.media-library.manage') || item.user_id == profile.user_id) && !item.is_hidden && (modal == null || !modal)">
                          <button type="button" class="dropdown-item" @click="onInvisible(item)">
                            <font-awesome-icon icon="fa-solid fa-eye-slash" class="fa-1x w-5 mr-2"/>
                            取出
                          </button>
                        </li>
                        <li v-if="hasPermission('delete', item) && (modal == null || !modal)">
                          <button type="button" class="dropdown-item" @click="openDeleteModal(item)">
                            <font-awesome-icon icon="fa-solid fa-trash" class="fa-1x w-5 mr-2"/>
                            刪除
                          </button>
                        </li>
                        <li><hr class="dropdown-divider" /></li>
                        <li class="dropdown-header">位置</li>
                        <li class="dropdown-text item-path">
                          <span v-if="$route.path !== '/library' || search !== ''" class="cursor-pointer" @click.stop="toRoute('/library')">檔案櫃</span>
                          <span v-else>檔案櫃</span>
                          <span v-for="(parentFolder, key) in getAllItemParentFolders(item.parentFolder)" :key="key">
                            <font-awesome-icon icon="fa-solid fa-chevron-right" class="ml-1 mr-1"/>
                            <span v-if="item != null && parentFolder.item_id == item.item_id" class="text-break">{{ parentFolder.item_name }}</span>
                            <span v-else @click.stop="toRoute(`/library/${parentFolder.item_code}`)" class="text-break cursor-pointer">{{ parentFolder.item_name }}</span>
                          </span>
                        </li>
                        <li><hr class="dropdown-divider" /></li>
                        <li class="dropdown-header">擁有者</li>
                        <li class="dropdown-text">{{ item.owner != null ? item.owner.display_name : '-' }}</li>
                        <li v-if="item.item_type === 'FILE'"><hr class="dropdown-divider" /></li>
                        <li v-if="item.item_type === 'FILE'" class="dropdown-header">檔案大小</li>
                        <li v-if="item.item_type === 'FILE'" class="dropdown-text">{{ getFileSize(item.file.file_size) }}</li>

                      </ul>
                    </div>
                  </div>

                  <button v-if="(item.item_type === 'FILE' && modal && (modalFilter == null || checkModalFilter(item))) || (item.item_type === 'DIRECTORY' && modalFolder && (!currentSelectedItem || item.item_id != currentSelectedItem.item_id) && (!modalFolderWriteOnly || hasPermission('write', item)))" @click.stop="$emit('select', item)" class="btn btn-primary ml-2 whitespace-nowrap">選擇</button>
                </div>
              </td>
              <td class="library-optional-col" @click="onOpen(item)">{{ item.created_at ?? '-' }}</td>
              <td @click="onOpen(item)">{{ item.updated_at ?? '-' }}</td>
              <td class="library-optional-col" v-if="!modal && !modalFolder" @click="onOpen(item)">{{ item.file_versions_count != null ? (item.file_versions_count) : '-' }}</td>
              <td class="library-optional-col" v-if="!modalFolder" @click="onOpen(item)">{{ item.item_type === 'FILE' ? getFileSize(item.file.file_size) : '' }}</td>
            </tr>
            </tbody>
          </table>
          </div>
        </div>
        <!-- END: Data List -->

        <!-- BEGIN: Upload Modal -->
        <div v-if="!modalFolder" id="upload-modal" class="modal" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h2 class="font-medium text-base mr-auto">
                  上載檔案
                </h2>
              </div>
              <div class="modal-body p-0">
                <div class="p-5">
                  <div class="text-slate-500 mt-2">
                    <form data-single="true" action="/" class="dropzone dropzoneAll mt-2">
                      <div class="fallback"><input name="file" type="file"/></div>
                      <div class="dz-message" data-dz-message>
                        <div class="text-lg font-medium">將檔案拖放到此處或單擊以上傳</div>
                        <div class="text-slate-500"> 檔案上限大小：100MB</div>
                      </div>
                    </form>
                  </div>
                </div>

                <div class="px-5 pb-8 text-center">
                  <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24">取消
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Upload Modal -->

        <!-- BEGIN: Create Folder Modal -->
        <div v-if="!modalFolder" id="create-folder-modal" class="modal" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h2 class="font-medium text-base mr-auto">
                  新增資料夾
                </h2>
              </div>
              <div class="modal-body p-0">
                <div class="p-5">
                  <div class="text-slate-500 mt-2">
                    <div class="">
                      <label class="form-label"><span class="text-danger">*</span> 名稱</label>
                      <input type="text" v-model="form.item_name" placeholder="請輸入名稱" class="form-control w-full"/>
                    </div>

                    <div class="mt-3">
                      <label class="form-label">簡介</label>
                      <input type="text" v-model="form.description" placeholder="請輸入簡介"
                             class="form-control w-full"/>
                    </div>
                  </div>
                </div>
                <div class="px-5 pb-8 text-center">
                  <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24 mr-1">取消
                  </button>
                  <button type="button" data-tw-dismiss="modal" class="btn btn-primary w-24 text-white"
                          :disabled="form.item_name == null || form.item_name === ''"
                          @click="onCreateFolder">確定
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Create Folder Modal -->

        <!-- BEGIN: View Modal -->
        <div id="view-modal" class="modal" tabindex="-1" aria-hidden="true" @click.self="onViewModalClose">
          <div class="flex justify-between align-items-center view-toolbar">
            <button type="button" @click="onDownload(viewItem, viewItem.item_name)" class="btn-download text-white">
              <font-awesome-icon icon="fa-solid fa-cloud-arrow-down" class="fa-2x"/>
            </button>

            <div class="text-white">{{ viewItem != null ? viewItem.item_name : ''}}</div>

            <button type="button" data-tw-dismiss="modal" class="btn-close text-white" @click="onViewModalClose">
              <font-awesome-icon icon="fa-solid fa-xmark" class="fa-2x"/>
            </button>
          </div>

          <div class="modal-dialog">
            <img v-if="viewItem != null && viewItem.file && viewItem.file.format && viewItem.file.format.mime_type.startsWith('image/')" :src="viewItem.view_url">
          </div>

          <div v-if="viewItem != null && viewItem.file && viewItem.file.format && !viewItem.file.format.mime_type.startsWith('image/')">
            <embed v-if="viewItem.file.format.mime_type === 'application/pdf'" :src="viewItem.view_url" class="iframe-viewer"/>
            <iframe
              v-else-if="isViewable(viewItem)"
              :src="`https://view.officeapps.live.com/op/embed.aspx?src=${viewItem.view_url}`" frameborder="0"
              class="iframe-viewer"></iframe>
          </div>

        </div>
        <!-- END: View Modal -->

        <!-- BEGIN: Rename Modal -->
        <div v-if="!modalFolder && !modal" id="rename-modal" class="modal" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h2 class="font-medium text-base mr-auto">
                  重新命名
                </h2>
              </div>
              <div class="modal-body p-0">
                <div class="p-5">
                  <div class="text-slate-500">
                    <div class="">
                      <label class="form-label"><span class="text-danger">*</span> 名稱</label>
                      <input type="text" v-model="form.item_name" placeholder="請輸入名稱" class="form-control w-full"/>
                    </div>

                    <div class="mt-3">
                      <label class="form-label">簡介</label>
                      <input type="text" v-model="form.description" placeholder="請輸入簡介"
                             class="form-control w-full"/>
                    </div>
                  </div>
                </div>
                <div class="px-5 pb-8 text-center">
                  <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24 mr-1">取消
                  </button>
                  <button type="button" data-tw-dismiss="modal" class="btn btn-primary w-24 text-white"
                          :disabled="form.item_name == null || form.item_name === ''"
                          @click="onRename">確定
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Rename Modal -->

        <!-- BEGIN: Permission Modal -->
        <div v-if="!modalFolder && !modal" id="items-permission-modal" class="modal" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h2 class="font-medium text-base mr-auto">
                  設定權限
                </h2>
              </div>
              <div class="modal-body p-0">
                <div class="p-5">
                  <div class="text-slate-500">
                    <div v-if="this.selectedItemIds.length > 0" class="">
                      <label class="form-label">權限</label>
                      <select v-model="form.site_permission" class="form-select" aria-label="請選擇權限">
                        <option v-if="item != null" value="">繼承資料夾「{{ item.item_name }}」</option>
                        <option v-else value="">繼承檔案櫃</option>
                        <option disabled>------------------------</option>
                        <option v-for="(item, key) in folderPermissions" :key="key" :value="item.value">{{
                            item.key
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="px-5 pb-8 text-center">
                  <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24 mr-1">取消</button>
                  <button type="button" data-tw-dismiss="modal" class="btn btn-primary w-24 text-white" @click="onSetItemsPermission">確定</button>
                </div>
              </div>
              <template v-if="selectItem !== 0 && selectItem != null">
                <div v-if="(item == null || (item != null && selectItem.item_id == item.item_id && parentFolders.length == 0)) && currentSite" class="modal-footer text-slate-500 text-left bg-slate-200">
                  <div class="">
                    <label class="form-label">檔案櫃的權限</label>
                    <div>{{ getObjectValue(folderPermissions, 'value', currentSite.library_root_permission, 'key') }}</div>
                  </div>
                </div>
                <div v-else-if="item != null && selectItem.item_id == item.item_id && parentFolders.length > 0" class="modal-footer text-slate-500 text-left bg-slate-200">
                  <div class="">
                    <label class="form-label">資料夾「{{ getLastParentFolder().item_name }}」的權限</label>
                    <div>{{ getFolderPermissionDisplay(getLastParentFolder()) }}</div>
                  </div>
                </div>
                <div v-else-if="item != null" class="modal-footer text-slate-500 text-left bg-slate-200">
                  <div class="">
                    <label class="form-label">資料夾「{{ item.item_name }}」的權限</label>
                    <div>{{ getFolderPermissionDisplay(item) }}</div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- END: Permission Modal -->

        <!-- BEGIN: Share Modal -->
        <div v-if="!modalFolder && !modal" id="permission-modal" class="modal" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog modal-xl ">
            <div class="modal-content">
              <div class="modal-header flex justify-between">
                <h2 class="font-medium text-base py-1">
                  設定權限
                </h2>
                <span v-show="loading"><i data-loading-icon="oval" class="w-8 h-8"></i></span>
              </div>
              <div class="modal-body p-0">
                <div class="p-5">
                  <div class="text-slate-500">
                    <div class="mb-3">
                      <label class="form-label"><template v-if="selectItem !== 0 && selectItem != null">{{ selectItem.item_type === 'DIRECTORY' ? '資料夾' : selectItem.item_type === 'FILE' ? '檔案' : '' }}</template>位置</label>
                      <div>
                        檔案櫃
                        <template v-for="(parentFolder, key) in parentFolders">
                          <font-awesome-icon icon="fa-solid fa-chevron-right" class="ml-1 mr-1" :key="key"/>
                          {{ parentFolder.item_name }}
                        </template>
                        <template v-if="item != null">
                          <font-awesome-icon icon="fa-solid fa-chevron-right" class="ml-1 mr-1"/>
                          {{ item.item_name }}
                        </template>
                        <template v-if="selectItem !== 0 && selectItem != null && (item == null || (item != null && selectItem.item_id != item.item_id))">
                          <font-awesome-icon icon="fa-solid fa-chevron-right" class="ml-1 mr-1"/>
                          {{ selectItem.item_name }}
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="" />

                <div class="p-5">
                  <div class="text-slate-500">
                    <div v-if="selectItem != null" class="mb-2">
                      <h2 class="font-medium text-slate-600 text-lg pb-3">
                        權限
                      </h2>
                      <select v-model="form.site_permission" class="form-select" aria-label="請選擇權限" :disabled="loading > 0">
                        <template v-if="selectItem !== 0">
                          <option v-if="(item == null || (item != null && selectItem.item_id == item.item_id && parentFolders.length == 0))" value="">繼承檔案櫃</option>
                          <option v-else-if="item != null && selectItem.item_id == item.item_id && parentFolders.length > 0" value="">繼承資料夾「{{ getLastParentFolder().item_name }}」</option>
                          <option v-else-if="item != null" value="">繼承資料夾「{{ item.item_name }}」</option>
                          <option disabled>------------------------</option>
                        </template>
                        <option v-for="(item, key) in folderPermissions" :key="key" :value="item.value">{{
                            item.key
                          }}
                        </option>
                      </select>
                    </div>

                    <button v-if="form.site_permission != form.old_site_permission" type="button" class="btn btn-primary w-24 text-white mt-1" :disabled="loading > 0" @click="onSetPermission">確定</button>
                  </div>
                </div>

                <template v-if="selectItem !== 0 && selectItem != null && form.site_permission == ''">
                  <div v-if="(item == null || (item != null && selectItem.item_id == item.item_id && parentFolders.length == 0)) && currentSite" class="p-5 text-slate-500 text-left bg-slate-200">
                    <div class="">
                      <label class="form-label">檔案櫃的權限</label>
                      <div>{{ getObjectValue(folderPermissions, 'value', currentSite.library_root_permission, 'key') }}</div>
                    </div>
                  </div>
                  <div v-else-if="item != null && selectItem.item_id == item.item_id && parentFolders.length > 0" class="p-5 text-slate-500 text-left bg-slate-200">
                    <div class="">
                      <label class="form-label">資料夾「{{ getLastParentFolder().item_name }}」的權限</label>
                      <div>{{ getFolderPermissionDisplay(getLastParentFolder()) }}</div>
                    </div>
                  </div>
                  <div v-else-if="item != null" class="p-5 text-slate-500 text-left bg-slate-200">
                    <div class="">
                      <label class="form-label">資料夾「{{ item.item_name }}」的權限</label>
                      <div>{{ getFolderPermissionDisplay(item) }}</div>
                    </div>
                  </div>
                  <hr v-else class="mt-1 mb-1" />
                </template>
                <hr v-else class="mt-1 mb-1" />

                <div class="p-5">
                  <div class="flex justify-between mb-3">
                    <h2 class="font-medium text-slate-600 text-lg py-1">
                      指定用戶／組別
                    </h2>
                    <template v-if="selectItem !== 0 && selectItem != null">
                      <button v-if="(item == null || (item != null && selectItem.item_id == item.item_id && parentFolders.length == 0)) && currentSite" type="button" class="btn btn-outline-primary" :disabled="loading > 0" @click="openCopyPermissionShare">
                        從檔案櫃複製
                      </button>
                      <button v-else-if="item != null && selectItem.item_id == item.item_id && parentFolders.length > 0" type="button" class="btn btn-outline-primary" :disabled="loading > 0"  @click="openCopyPermissionShare">
                        從資料夾「{{ getLastParentFolder().item_name }}」複製
                      </button>
                      <button v-else-if="item != null" type="button" class="btn btn-outline-primary" :disabled="loading > 0" @click="openCopyPermissionShare">
                        從資料夾「{{ item.item_name }}」複製
                      </button>
                    </template>
                  </div>
                  <div class="text-slate-500">
                    <div>
                      <div class="mt-2 flex">
                        <button type="button" class="flex-1 btn mr-2" :class="{'btn-primary': shareType === 'user', 'btn-secondary': shareType !== 'user'}" @click="shareType = 'user'">用戶</button>
                        <button type="button" class="flex-1 btn" :class="{'btn-primary': shareType === 'group', 'btn-secondary': shareType !== 'group'}" @click="shareType = 'group'">組別</button>
                      </div>

                      <div v-if="shareType === 'user'">
                        <div v-if="selectUser == null" class="mt-3">
                          <label class="form-label">選擇用戶</label>
                          <multi-select v-model="userIds" :options="userOptions" :multiple="true" :close-on-select="false" :clear-on-select="true" :preserve-search="true" placeholder="以名搜尋" selectLabel="按下Enter以選擇" label="searchLabel" track-by="email" :preselect-first="false" :hide-selected="true" >
                            <template slot="noResult"><span class="multiselect__option">沒有結果，請輸入其他字</span></template>
                          </multi-select>
                        </div>

                        <div v-else class="mt-3">
                          <label class="form-label">用戶</label>
                          <div>{{ getObjectValue(users, 'user_id', selectUser.user_id, 'display_name') }}</div>
                        </div>
                      </div>

                      <div v-if="shareType === 'group'">
                        <div v-if="selectGroup === null" class="mt-3">
                          <label class="form-label">選擇組別</label>
                          <multi-select v-model="userGroupIds" :options="userGroupOptions" :multiple="true" :close-on-select="false" :clear-on-select="true" :preserve-search="true" placeholder="以名搜尋" selectLabel="按下Enter以選擇" label="display_name" track-by="group_id" :preselect-first="false" :hide-selected="true">
                            <template slot="noResult"><span class="multiselect__option">沒有結果，請輸入其他字</span></template>
                          </multi-select>
                        </div>

                        <div v-else class="mt-3">
                          <label class="form-label">組別</label>
                          <div>{{ getObjectValue(userGroups, 'group_id', selectGroup.group_id, 'display_name')}}</div>
                        </div>
                      </div>

                      <div class="mt-3">
                        <label for="role-id" class="form-label">權限</label>
                        <select v-model="form.permission" id="role-id" class="form-select mt-2 sm:mr-2" aria-label="Default select example">
                          <option value="">--- 請選擇 ---</option>
                          <option v-for="(item, key) in folderPermissions" :key="key" :value="item.value">{{ item.key }}</option>
                        </select>
                      </div>

                      <button v-if="(shareType === 'user' && selectUser == null) || (shareType === 'group' && selectGroup == null)" type="button" class="btn btn-primary w-24 text-white mt-3"
                              :disabled="loading > 0 || form.permission === '' || (userIds.length === 0 && userGroupIds.length === 0)"
                              @click="onAddShare">新增
                      </button>

                      <button v-else type="button" class="btn btn-pending w-24 text-white mt-3"
                              :disabled="loading > 0 || form.permission === ''"
                              @click="onUpdateShare">更改
                      </button>
                    </div>

                    <hr class="mt-5 mb-2" />

                    <div v-if="shareType === 'user'">
                      <label class="mt-4 form-label">已設定的用戶</label>
                    </div>

                    <div v-if="shareType === 'group'">
                      <label class="mt-4 form-label">已設定的組別</label>
                    </div>

                    <div class="flex justify-between">
                      <button type="button" class="btn flex-1" :class="{'btn-primary': selectedFolderPermission === '', 'btn-secondary': selectedFolderPermission !== ''}" @click="selectedFolderPermission = ''">全部</button>
                      <button type="button" v-for="(item, key) in folderPermissions" :key="key" class="btn flex-1 ml-1" :class="{'btn-primary': selectedFolderPermission === item.value, 'btn-secondary': selectedFolderPermission !== item.value }" @click="selectedFolderPermission = item.value">{{ item.key }}</button>
                    </div>
                    <div class="flex justify-end mt-3">
                      <div class="w-56 relative text-slate-500 ml-2">
                        <input v-model="searchFolderPermission" type="text" class="form-control sm:w-56 pr-10" placeholder="搜尋" @keyup.enter="clickSearchFolderPermission">
                        <button class="absolute my-auto w-4 h-4 mr-3 right-0 inset-y-0" type="button" @click="clickSearchFolderPermission"><font-awesome-icon icon="fa-solid fa-magnifying-glass" /></button>
                      </div>
                    </div>

                    <div v-if="shareType === 'user'">
                      <div v-if="shareFilteredUsers" class="grid grid-cols-12 gap-6 mt-4">
                        <div v-for="(item, key) in shareFilteredUsers" :key="key" class="intro-y col-span-12 md:col-span-6">
                          <div class="box">
                            <div class="flex flex-col lg:flex-row items-center p-5">
                              <div class="flex-shrink-0 w-24 h-24 lg:w-12 lg:h-12 image-fit lg:mr-1">
                                <img alt="" class="rounded-full" :src="item.avatar_url != null && item.avatar_url !== '' ? item.avatar_url : '/images/user.png'">
                              </div>
                              <div class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0">
                                <div class="font-medium text-left">{{ item.user?.display_name ?? item.user?.full_name }}</div>
                                <div class="text-slate-500 text-xs mt-0.5">
                                  {{ getObjectValue(folderPermissions, 'value', item.permission, 'key') }}
                                  <template v-if="item.inherited_from === 0"> （繼承檔案櫃<template v-if="item.group">組別「{{ item.group.display_name }}」</template>）</template>
                                  <template v-else-if="item.inherited_from"> （繼承資料夾「{{ item.inherited_from.item_name }}」<template v-if="item.group">組別「{{ item.group.display_name }}」</template>）</template>
                                  <template v-else-if="item.group"> （組別「{{ item.group.display_name }}」）</template>
                                </div>
                              </div>
                              <div class="flex mt-4 lg:mt-0" v-if="selectUser == null && item.id != null && !item.is_inherited">
                                <button class="btn btn-outline-pending py-1 px-2 mr-2 whitespace-nowrap" @click="onStartUpdateShare(item)" v-if="selectItem === 0 || hasPermission('write', selectItem)">更改</button>
                                <button class="btn btn-outline-danger py-1 px-2 whitespace-nowrap" @click="onRemoveShare(item)" v-if="selectItem === 0 || hasPermission('write', selectItem)">移除</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="shareFilteredUsers && shareFilteredUsers.length === 0" class="text-center p-6 mt-5">
                        沒有用戶
                      </div>
                    </div>

                    <div v-show="shareType === 'user' && shareFilteredUsers == null" class="text-center p-6 mt-5">
                      <div class="inline-block"><i data-loading-icon="oval" class="w-8 h-8"></i></div>
                    </div>

                    <div v-if="shareType === 'group'">
                      <div v-if="shareFilteredGroups" class="grid grid-cols-12 gap-6 mt-4">
                        <div v-for="(item, key) in shareFilteredGroups" :key="key" class="intro-y col-span-12 md:col-span-6">
                          <div class="box">
                            <div class="flex flex-col lg:flex-row items-center p-5">
                              <div class="lg:mr-auto text-center lg:text-left">
                                <div class="font-medium pointer" @click="openUserGroupUsersViewerModal(item.userGroup)">{{ item.userGroup ? item.userGroup.display_name : ('#' + item.group_id) }}</div>
                                <div class="text-slate-500 text-xs mt-0.5">
                                  {{ getObjectValue(folderPermissions, 'value', item.permission, 'key') }}
                                  <template v-if="item.inherited_from === 0"> （繼承檔案櫃）</template>
                                  <template v-else-if="item.inherited_from"> （繼承資料夾「{{ item.inherited_from.item_name }}」）</template>
                                </div>
                              </div>
                              <div class="flex mt-4 lg:mt-0" v-if="selectGroup == null && !item.is_inherited">
                                <button class="btn btn-outline-pending py-1 px-2 mr-2 whitespace-nowrap" @click="onStartUpdateShareGroup(item)" v-if="selectItem === 0 || hasPermission('write', selectItem)">更改</button>
                                <button class="btn btn-outline-danger py-1 px-2 whitespace-nowrap" @click="onRemoveShareGroup(item)" v-if="selectItem === 0 || hasPermission('write', selectItem)">移除</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="shareFilteredGroups && shareFilteredGroups.length === 0" class="text-center p-6 mt-5">
                        沒有組別
                      </div>
                    </div>

                    <div v-show="shareType === 'group' && shareFilteredGroups == null" class="text-center p-6 mt-5">
                      <div class="inline-block"><i data-loading-icon="oval" class="w-8 h-8"></i></div>
                    </div>
                  </div>
                </div>
                <div class="px-5 pb-8 text-center">
                  <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24 mr-1">關閉
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Share Modal -->

        <!-- BEGIN: Version Modal -->
        <div v-if="!modalFolder && !modal" id="version-modal" class="modal" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog modal-xl ">
            <div class="modal-content">
              <div class="modal-header flex justify-between">
                <h2 class="font-medium text-base py-1">
                  檢視版本
                </h2>
                <span v-show="loading"><i data-loading-icon="oval" class="w-8 h-8"></i></span>
              </div>
              <div class="modal-body p-0">
                <div class="p-5">
                  <div class="text-slate-500">
                    <div>
                      <label class="form-label">上載新版本</label>
                      <form data-single="true" action="/" class="dropzone dropzoneOne mt-2">
                        <div class="fallback"><input name="file" type="file"/></div>
                        <div class="dz-message" data-dz-message>
                          <div class="text-lg font-medium">將檔案拖放到此處或單擊以上傳</div>
                          <div class="text-slate-500"> 檔案上限大小：100MB</div>
                        </div>
                      </form>
                    </div>

                    <hr class="mt-5 mb-2" />

                    <label class="mt-4 form-label">所有版本</label>

                    <div v-if="itemVersions && itemVersions.length > 0" class="overflow-x-auto">
                      <table class="table table-striped">
                        <thead>
                        <tr>
                          <th class="whitespace-nowrap">版本</th>
                          <th class="whitespace-nowrap">名稱</th>
                          <th class="whitespace-nowrap">上載者</th>
                          <th class="whitespace-nowrap">版本日期</th>
                          <th class="whitespace-nowrap">檔案大小</th>
                          <th class="text-center whitespace-nowrap"></th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr class="" v-for="(item, key) in itemVersions" :key="key" :class="{'font-bold': selectItem.file?.version_id === item.version_id}">
                          <td>{{ itemVersions.length - key }}</td>
                          <td>{{ item.file_name ?? '-' }}</td>
                          <td>{{ item.owner.full_name ?? '-' }}</td>
                          <td>{{ item.created_at ?? '-' }}</td>
                          <td>{{ getFileSize(item.file_size) }}</td>
                          <td
                            class="table-report__action w-56">
                            <div class="flex justify-center items-center">
                              <button v-if="hasPermission('read', selectItem)" type="button" @click="onDownload(selectItem, item.file_name, item.version_id)" class="flex items-center text-primary">
                                <font-awesome-icon icon="fa-solid fa-cloud-arrow-down"/>
                                &nbsp;下載
                              </button>
                              <button v-if="selectItem.file?.version_id !== item.version_id && hasPermission('write', selectItem)" type="button" @click="onChangeVersion(item.version_id)" class="flex items-center ml-4 text-warning">
                                <font-awesome-icon icon="fa-solid fa-arrow-rotate-left"/>
                                &nbsp;回復
                              </button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-if="itemVersions && itemVersions.length === 0" class="text-center p-6 mt-5">
                      沒有版本
                    </div>

                    <div v-show="itemVersions == null" class="text-center p-6 mt-5">
                      <div class="inline-block"><i data-loading-icon="oval" class="w-8 h-8"></i></div>
                    </div>
                  </div>
                </div>
                <div class="px-5 pb-8 text-center">
                  <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24 mr-1">關閉
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Version Modal -->

        <!-- BEGIN: Tag Modal -->
        <div v-if="!modalFolder && !modal" id="tag-modal" class="modal" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog modal-xl ">
            <div class="modal-content">
              <div class="modal-header flex justify-between">
                <h2 class="font-medium text-base py-1">
                  管理標籤
                </h2>
                <span v-show="loading"><i data-loading-icon="oval" class="w-8 h-8"></i></span>
              </div>
              <div class="modal-body p-0">
                <div class="p-5">
                  <div class="text-slate-500">
                    <div v-if="this.selectedItemIds.length == 0" class="mb-3">
                      <label class="form-label"><template v-if="selectItem !== 0 && selectItem != null">{{ selectItem.item_type === 'DIRECTORY' ? '資料夾' : selectItem.item_type === 'FILE' ? '檔案' : '' }}</template>位置</label>
                      <div>
                        檔案櫃
                        <template v-for="(parentFolder, key) in parentFolders">
                          <font-awesome-icon icon="fa-solid fa-chevron-right" class="ml-1 mr-1" :key="key"/>
                          {{ parentFolder.item_name }}
                        </template>
                        <template v-if="item != null">
                          <font-awesome-icon icon="fa-solid fa-chevron-right" class="ml-1 mr-1"/>
                          {{ item.item_name }}
                        </template>
                        <template v-if="selectItem !== 0 && selectItem != null && (item == null || (item != null && selectItem.item_id != item.item_id))">
                          <font-awesome-icon icon="fa-solid fa-chevron-right" class="ml-1 mr-1"/>
                          {{ selectItem.item_name }}
                        </template>
                      </div>
                    </div>

                    <div>
                      <label class="form-label">新增標籤</label>
                      <multi-select v-model="form.tags" :options="tagOptions" :multiple="true" :close-on-select="false" :clear-on-select="true" :preserve-search="true" placeholder="以名搜尋" selectLabel="按下Enter以選擇" label="tag_name_with_level" track-by="tag_id" :preselect-first="true" :hide-selected="true" >
                        <template slot="noResult"><span class="multiselect__option">沒有結果，請輸入其他字</span></template>
                      </multi-select>

                      <template v-if="selectUser == null">
                        <button v-if="this.selectedItemIds.length == 0" type="button" class="btn btn-primary w-24 text-white mt-3"
                                :disabled="form.tags == null || form.tags.length === 0"
                                @click="onAddItemTags">新增
                        </button>
                        <button v-else data-tw-dismiss="modal" type="button" class="btn btn-primary w-24 text-white mt-3"
                                :disabled="form.tags == null || form.tags.length === 0"
                                @click="onAddItemTags">新增
                        </button>
                      </template>
                    </div>

                    <template v-if="selectItem">
                      <hr class="mt-5 mb-2" />

                      <label class="mt-4 form-label">所有標籤</label>

                      <div v-if="itemTags && itemTags.length > 0" class="grid grid-cols-12 gap-5 mt-5">
                        <div class="col-span-12 sm:col-span-4 2xl:col-span-3 box p-5 flex justify-between align-items-center" v-for="(item, key) in itemTags" :key="key">
                          <div class="font-medium text-base">{{ item.tag_name }}</div>
                          <button class="btn btn-outline-danger py-1 px-2" @click="onRemoveItemTag(item.tag_id)">移除</button>
                        </div>
                      </div>

                      <div v-if="itemTags && itemTags.length === 0" class="text-center p-6 mt-5">
                        沒有標籤
                      </div>

                      <div v-show="itemTags == null" class="text-center p-6 mt-5">
                        <div class="inline-block"><i data-loading-icon="oval" class="w-8 h-8"></i></div>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="px-5 pb-8 text-center">
                  <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24 mr-1">關閉
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Tag Modal -->

        <!-- BEGIN: Delete Confirmation Modal -->
        <div v-if="!modalFolder" id="delete-confirmation-modal" class="modal" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body p-0">
                <div class="p-5 text-center">
                  <font-awesome-icon icon="fa-regular fa-circle-xmark" class="fa-3x text-danger" />
                  <div class="text-3xl mt-5">你確定嗎？</div>
                  <div class="text-slate-500 mt-2">
                    你是否要刪除此檔案？
                    <br>
                    這動作不能還原。
                  </div>
                </div>
                <div class="px-5 pb-8 text-center">
                  <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24 mr-1">取消</button>
                  <button type="button" data-tw-dismiss="modal" class="btn btn-danger w-24" @click="onDelete">確定</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Delete Confirmation Modal -->

        <!-- BEGIN: Share Copy Confirmation Modal -->
        <div v-if="!modalFolder" id="permission-share-copy-confirmation-modal" class="modal" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body p-0">
                <div class="p-5 text-center">
                  <font-awesome-icon icon="fa-regular fa-circle-question" class="fa-3x text-primary" />
                  <div class="text-3xl mt-5">你確定嗎？</div>
                  <div class="text-slate-500 mt-2">
                    你是否要複製權限的指定用戶／組別嗎？
                    <br>
                    這動作不能還原。
                  </div>
                </div>
                <div class="px-5 pb-8 text-center">
                  <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24 mr-1">取消</button>
                  <button type="button" data-tw-dismiss="modal" class="btn btn-primary w-24" @click="onCopyPermissionShare">確定</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Delete Confirmation Modal -->

      </div>
    </div>

    <folder-selector v-if="!modalFolder" :auth="auth" :current-site="currentSite" :permissions="permissions" :modalFolderWriteOnly="true" @on-select="onSelectFolder" ref="folderSelector"></folder-selector>

    <user-group-users-viewer v-if="!modalFolder" :auth="auth" :current-site="currentSite" :permissions="permissions" ref="userGroupUsersViewer"></user-group-users-viewer>
  </div>
</template>

<script>
export default {
  props: ['auth', 'currentSite', 'permissions', 'profile', 'modal', 'modalFilter', 'modalFolderCode', 'modalFolder', 'currentSelectedItem', 'modalFolderWriteOnly'],
  data() {
    return {
      mounted: false,

      host: '',
      currentLibrarySiteReloaded: false,
      currentLibrarySite: null,

      folderCode: '',
      fileCode: '',
      parentFolders: [],
      item: null,
      items: [],
      currentItemId: null,
      levelTags: [],

      downloading: false,
      clicking: false,

      tag: '',
      search: '',
      searched: '',
      searchInput: '',
      orderBy: '',
      order: '',
      loading: 0,

      userIds: [],
      userGroupIds: [],

      form: {
        folder_id: null,
        item_name: null,
        description: null,
        site_permission: '',
        user_id: null,
        group_id: null,
        permission: '',
        tags: null
      },

      folderPermissions: [
        { value: 'full', key: '可讀寫刪' },
        { value: 'writable', key: '可讀寫' },
        { value: 'readable', key: '可讀' },
        { value: 'restricted', key: '限制： 不可讀寫刪' }
      ],

      selectItem: null,
      viewItem: null,

      itemVersions: null,
      users: [],
      userGroups: [],
      shareUsers: [],
      shareFilteredUsers: null,
      shareGroups: [],
      shareFilteredGroups: null,
      userOptions: [],
      userGroupOptions: [],
      selectUser: null,
      groupOptions: [],
      selectGroup: null,

      // shareItem: null,
      selectedFolderPermission: '',
      searchFolderPermission: '',

      itemTags: [],
      tagOptions: [],

      selectedItemIds: [],
      action: false,
      folderAction: false,

      shareType: 'user'
    }
  },
  watch: {
    auth(val) {
      if (val) {
        this.init()
      }
    },
    currentSite(val) {
      if (this.currentLibrarySite == null || this.currentLibrarySite.site_id !== val.site_id) {
        this.init()
      }
      this.currentLibrarySite = val
    },
    '$route'(val) {
      this.init()
    },
    search(val) {
      if (val === '') {
        this.searched = ''
      }
    },
    searchInput(val) {
      if (val == null || val === '') {
        this.search = ''
        this.loadLibraryItems()
      }
    },
    tag(val) {
      if (val == null || val === '') {
        this.loadLibraryItems()
      } else {
        this.searchInput = ''
        this.search = ''
        this.onSearch()
      }
    },
    shareType(val) {
      this.selectedFolderPermission = ''
      this.searchFolderPermission = ''
    },
    searchFolderPermission(val) {
      if (val == null || val === '') {
        this.onFilterShare()
      }
    },
    order() {
      this.loadLibraryItems()
    },
    selectedFolderPermission() {
      this.onFilterShare()
    },
    async modalFolderCode(val) {
      if (val) {
        this.onChangeFolder(val)
      } else {
        this.onChangeFolder('')
      }
      this.loadLibraryItems(true)
    }
  },
  async mounted() {
    window.tailwind.svgLoader()
    if (!this.auth) {
      return
    }

    await this.init()
  },
  methods: {
    async init() {
      this.host = window.location.protocol + '//' + window.location.host
      this.parentFolders = []
      this.item = null
      this.folderCode = this.$route.params.folderCode ?? ''
      this.fileCode = this.$route.params.fileCode ?? ''

      if (this.currentSite) {
        if (!this.mounted) {
          if (!this.modal && !this.modalFolder) {
            if (!this.currentLibrarySiteReloaded) {
              this.currentLibrarySiteReloaded = true
              this.$root.$children[0].updateCurrentSiteData(this.currentSite.site_id)
            }
            this.loadUsers()
            this.loadUserGroups()
          }

          this.loadTags()
        }

        if (typeof this.modalFolderCode !== 'undefined' && this.modalFolderCode !== '') {
          this.folderCode = this.modalFolderCode
        }

        if (this.search === '') {
          await this.getItem()
          await this.loadLibraryItems(true)
        }

        if (!this.mounted) {
          window.tailwind.svgLoader()

          if (!this.modalFolder) {
            this.$nextTick(() => {
              this.dropZoneAll()
              this.dropZoneOne()

              const self = this

              this.$nextTick(() => {
                this.$dz.on('addedfile', async function(file) {
                  await self.onUpload(file)
                })

                this.$dz.on('addedfiles', function() {
                  const el = document.querySelector('#upload-modal')
                  const modal = window.tailwind.Modal.getOrCreateInstance(el)
                  modal.hide()

                  self.$dz.removeAllFiles()
                })

                if (this.$dz1) {
                  this.$dz1.on('addedfile', async function(file) {
                    await self.onUploadNewVersion(file)
                    self.$dz1.removeAllFiles()
                  })
                }
              })
            })
          }
        }

        this.mounted = true
      }
    },
    async onChangeFolder(folderCode = '') {
      this.parentFolders = []
      this.item = null
      this.folderCode = folderCode

      if (this.currentSite) {
        await this.getItem()
        await this.loadLibraryItems(true)
      }
    },
    async getItem() {
      this.loading++

      if (this.folderCode !== '' && this.folderCode !== null) {
        const response = await this.getLibraryItem(this.currentSite.site_id, this.folderCode)

        if (response.code === 0) {
          this.item = response.data
        } else {
          if (this.modal || this.modalFolder) {
            this.folderCode = ''
            await this.getItem()
          } else {
            this.$router.push('/library').catch(() => {})
          }
        }
      } else if (this.fileCode !== '' && this.fileCode !== null) {
        const response = await this.getLibraryItem(this.currentSite.site_id, this.fileCode)

        if (response.code === 0) {
          this.item = response.data
          if (this.item.item_type === 'DIRECTORY') {
            this.onOpen(this.item)
          } else if (this.item.item_type === 'FILE') {
            this.openViewModal(this.item)
            if (this.item.parentFolder != null) {
              this.fileCode = ''
              this.$router.replace(`/library/${this.item.parentFolder.item_code}`).catch(() => {})
            } else {
              this.fileCode = ''
              this.$router.push('/library').catch(() => {})
            }
          }
        } else {
          this.$router.push('/library').catch(() => {})
        }
      }

      this.loading--
    },
    async loadLibraryItems(getParent = false) {
      this.loading++

      const response = await this.getLibraryItems(this.currentSite.site_id, this.folderCode ?? '', this.orderBy, this.order)

      if (response.code === 0) {
        this.searched = ''

        if (getParent) {
          this.getAllParentFolders(response.parentFolder, true)
        }

        this.loadItems(response.data)
      } else {
        this.$notify({
          title: '未能載入資料夾',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        })
      }

      setTimeout(() => {
        this.loading--
      }, 500)
    },
    async getAllParentFolders(parentFolder, resetCurrent = false) {
      this.loading++

      if (resetCurrent) {
        this.parentFolders = []
      }

      if (parentFolder != null) {
        this.parentFolders.unshift(parentFolder)

        this.getAllParentFolders(parentFolder.parentFolder)
      }

      this.loading--
    },
    getLastParentFolder() {
      if (this.parentFolders.length > 0) {
        return this.parentFolders[(this.parentFolders.length - 1)]
      }
      return null
    },
    onOpen(item) {
      this.loading++
      if (this.clicking) {
        this.loading--
        return
      }

      this.clicking = true

      if (!this.hasPermission('read', item)) {
        this.loading--
        return
      }

      this.selectedItemIds = []
      this.action = false

      if (item.item_type === 'DIRECTORY') {
        this.searchInput = ''
        this.search = ''
        if (this.modal || this.modalFolder) {
          this.onChangeFolder(item.item_code)
        } else {
          this.$router.push(`/library/${item.item_code}`).catch(() => {})
        }
      } else {
        this.openViewModal(item)
      }
      setTimeout(() => {
        scrollTo(0, 0)
        this.clicking = false
        this.loading--
      }, 1000)
    },
    onClick(item) {
      this.currentItemId = item.item_id
    },
    toRoute(route) {
      if (!this.modal && !this.modalFolder) {
        this.searchInput = ''
        this.search = ''
        if (this.$route.path !== route) {
          this.$router.push(route).catch(() => {})
        }
      }
    },
    onUnselect() {
      this.currentItemId = null
    },
    async clickSearch() {
      if (this.searchInput == null || this.searchInput === '') {
        this.loadLibraryItems()
      } else {
        this.tag = ''
        this.search = this.searchInput
        await this.onSearch()
      }
    },
    async onSearch() {
      this.loading++

      const response = await this.searchLibraryItems(this.currentSite.site_id, this.search, this.tag)

      if (response.code === 0) {
        this.orderBy = ''
        this.order = ''

        this.loadItems(response.data)

        this.searched = this.search

        if (this.$route.path !== '/library' && !this.modal && !this.modalFolder) {
          this.$router.push('/library').catch(() => {})
        }
      } else {
        this.$notify({
          title: '未能搜尋',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        })
      }
      setTimeout(() => {
        this.loading--
      }, 500)
    },
    loadItems(items) {
      if (this.selectItem != null) {
        for (let i = 0; i < items.length; i++) {
          if (this.selectItem.item_id === items[i].item_id) {
            this.selectItem = items[i]

            break
          }
        }
      }
      this.items = this.modalFolder ? items.filter((x) => x.item_type === 'DIRECTORY') : items
    },
    getAllItemParentFolders(item) {
      if (item != null) {
        if (item.parentFolder != null) {
          return this.getAllItemParentFolders(item.parentFolder).concat([item])
        }
        return [item]
      }
      return []
    },
    getFolderPermissionItem(item) {
      if (item != null) {
        if (item.site_permission) {
          return {
            item_id: item.item_id,
            item_name: item.item_name,
            permission: item.site_permission
          }
        }
        if (item.parentFolder) {
          return this.getFolderPermissionItem(item.parentFolder)
        } else if (item.folder_id === 0 && this.currentSite && this.currentSite.library_root_permission !== '') {
          return {
            item_id: 0,
            item_name: null,
            permission: this.currentSite.library_root_permission
          }
        }
      }
      return {
        item_id: null,
        item_name: null,
        permission: 'restricted'
      }
    },
    getFolderPermissionDisplay(item) {
      const permissionItem = this.getFolderPermissionItem(item)
      let result = this.getObjectValue(this.folderPermissions, 'value', permissionItem.permission, 'key')

      if (item != null) {
        if (permissionItem.item_id === 0) {
          result += ' （繼承檔案櫃）'
        } else if (permissionItem.item_id !== null && item.item_id !== permissionItem.item_id) {
          result += ` （繼承資料夾「${permissionItem.item_name}」）`
        }
      }

      return result
    },
    openUploadModal() {
      const el = document.querySelector('#upload-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()
    },
    async onUpload(file) {
      if (file.size > 100000000) {
        this.$notify({
          title: '未能上載檔案',
          message: '檔案大小不能超過 100MB',
          type: 'error'
        })
        return
      }

      this.loading++

      const response = await this.uploadLibraryItem(this.currentSite.site_id, (this.item != null ? this.item.item_id : 0), file)

      let option = {
        title: '成功',
        message: `已上載檔案：${file.name}`,
        type: 'success'
      }

      if (response.code === 0) {
        this.loadLibraryItems()
      } else {
        option = {
          title: `未能上載檔案：${file.name}`,
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        }
      }

      this.$notify(option)

      this.loading--
    },
    openCreateFolderModal() {
      const el = document.querySelector('#create-folder-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()
    },
    async onCreateFolder() {
      const el = document.querySelector('#create-folder-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.hide()

      const response = await this.createLibraryFolder(this.currentSite.site_id, {
        folder_id: (this.item != null ? this.item.item_id : 0),
        item_name: this.form.item_name,
        description: this.form.description
      })

      let option = {
        title: '成功',
        message: '已新增資料夾',
        type: 'success'
      }

      if (response.code === 0) {
        this.loadLibraryItems()
      } else {
        option = {
          title: '未能新增資料夾',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        }
      }

      this.$notify(option)

      this.form.item_name = null
      this.form.description = null
    },
    getHighestPermission(permission1, permission2) {
      if (permission1 === 'restricted' || permission2 === 'restricted') {
        return 'restricted'
      } if (permission1 === 'full' || permission2 === 'full') {
        return 'full'
      } else if (permission1 === 'writable' || permission2 === 'writable') {
        return 'writable'
      } else if (permission1 === 'readable' || permission2 === 'readable') {
        return 'readable'
      }
      return permission1
    },
    hasPermission(permission, item) {
      let itemPermissio = null

      if (item && item !== 0) {
        if (item.user_permission === 'restricted') {
          return false
        }
        itemPermissio = item.user_permission
      } if (item === null || item === 0) {
        if (!(this.currentSite && this.currentSite.library_user_permission)) {
          return this.checkPermission(this.permissions, 'site.media-library.manage')
        }
        itemPermissio = this.currentSite.library_user_permission
      }
      if (itemPermissio === null) {
        return false
      }

      switch (permission) {
        case 'read':
          switch (itemPermissio) {
            case 'full': return true
            case 'readable': return true
            case 'writable': return true
            default: return false
          }
        case 'write':
          switch (itemPermissio) {
            case 'full': return true
            case 'writable': return true
            default: return false
          }
        case 'delete':
          switch (itemPermissio) {
            case 'full': return true
            default: return false
          }
      }

      // if (item.site_permission === 'restricted') {
      //   return false
      // } else if (item.site_permission === '') {
      //   return true
      // }
      //
      // switch (permission) {
      //   case 'read':
      //     switch (item.site_permission) {
      //       case 'full': return true
      //       case 'readable': return true
      //       default: return false
      //     }
      //   case 'write':
      //     switch (item.site_permission) {
      //       case 'full': return true
      //       case 'writable': return true
      //       default: return false
      //     }
      //   case 'delete':
      //     switch (item.site_permission) {
      //       case 'full': return true
      //       default: return false
      //     }
      // }

      return false
    },
    hasNoPermission(item) {
      if (item.user_permission === 'restricted') {
        return true
      }

      // else if (item.site_permission === 'restricted') {
      //   return true
      // }

      return false
    },
    async openViewModal(item) {
      this.loading++
      const response = await this.getLibraryItem(this.currentSite.site_id, item.item_code)

      if (response.code === 0) {
        this.viewItem = response.data

        if (this.isViewable(item)) {
          const el = document.querySelector('#view-modal')
          const modal = window.tailwind.Modal.getOrCreateInstance(el)
          modal.show()
        } else {
          this.onDownload(item, item.item_name)
        }
      }
      this.loading--
    },
    onViewModalClose() {
      this.viewItem = null
    },
    async onDownload(item, filename = null, versionId = '') {
      this.downloading = true
      const response = await this.downloadLibraryItem(this.currentSite.site_id, item.item_code, versionId)
      const blob = new Blob([response], { type: item.file.format != null ? item.file.format.mime_type : null })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = filename ?? item.file.file_name
      link.click()
      URL.revokeObjectURL(link.href)
      this.downloading = false
    },
    async onVisible(item) {
      this.loading++

      if (item != null) {
        this.selectItem = item

        const response = await this.updateLibraryItemVisibility(this.currentSite.site_id, this.selectItem.item_code, { is_hidden: false })

        if (response.code === 0) {
          this.$notify({
            title: '成功',
            message: '已被發佈',
            type: 'success'
          })

          this.loadLibraryItems()
        } else {
          this.$notify({
            title: '未能發佈',
            message: response.data.message ?? '系統錯誤，請稍後再試',
            type: 'error'
          })
        }
      } else if (this.selectedItemIds.length > 0) {
        let success = 0
        for (let i = 0; i < this.selectedItemIds.length; i++) {
          const item = this.getSelectedItem(this.selectedItemIds[i])
          if (item) {
            const response = await this.updateLibraryItemVisibility(this.currentSite.site_id, item.item_code, { is_hidden: false })

            if (response.code === 0) {
              success++
            }
          }
        }
        if (this.selectedItemIds.length === success) {
          this.$notify({
            title: '成功',
            message: '已被發佈',
            type: 'success'
          })
        } else if (success > 0) {
          this.$notify({
            title: '部份發佈',
            message: '未能發佈全部項目',
            type: 'error'
          })
        } else {
          this.$notify({
            title: '未能發佈',
            message: '系統錯誤，請稍後再試',
            type: 'error'
          })
        }

        this.selectedItemIds = []

        this.loadLibraryItems()
      }

      this.loading--
    },
    async onInvisible(item) {
      this.loading++

      if (item != null) {
        this.selectItem = item

        const response = await this.updateLibraryItemVisibility(this.currentSite.site_id, this.selectItem.item_code, { is_hidden: true })

        if (response.code === 0) {
          this.$notify({
            title: '成功',
            message: '已被取出',
            type: 'success'
          })

          this.loadLibraryItems()
        } else {
          this.$notify({
            title: '未能取出',
            message: response.data.message ?? '系統錯誤，請稍後再試',
            type: 'error'
          })
        }
      } else if (this.selectedItemIds.length > 0) {
        let success = 0
        for (let i = 0; i < this.selectedItemIds.length; i++) {
          const item = this.getSelectedItem(this.selectedItemIds[i])
          if (item) {
            const response = await this.updateLibraryItemVisibility(this.currentSite.site_id, item.item_code, { is_hidden: true })

            if (response.code === 0) {
              success++
            }
          }
        }
        if (this.selectedItemIds.length === success) {
          this.$notify({
            title: '成功',
            message: '已被取出',
            type: 'success'
          })
        } else if (success > 0) {
          this.$notify({
            title: '部份取出',
            message: '未能取出全部項目',
            type: 'error'
          })
        } else {
          this.$notify({
            title: '未能取出',
            message: '系統錯誤，請稍後再試',
            type: 'error'
          })
        }

        this.selectedItemIds = []

        this.loadLibraryItems()
      }

      this.loading--
    },
    openRenameModal(item) {
      this.selectItem = item

      this.form.item_name = this.selectItem.item_name
      this.form.description = this.selectItem.description

      const el = document.querySelector('#rename-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()
    },
    async onRename() {
      const el = document.querySelector('#rename-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.hide()

      const response = await this.updateLibraryItem(this.currentSite.site_id, this.selectItem.item_code, {
        item_name: this.form.item_name,
        description: this.form.description
      })

      let option = {
        title: '成功',
        message: '已重新命名',
        type: 'success'
      }

      if (response.code === 0) {
        if (this.item != null && this.selectItem.item_id === this.item.item_id) {
          this.getItem()
        }
        this.loadLibraryItems()
      } else {
        option = {
          title: '未能重新命名',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        }
      }

      this.$notify(option)

      this.form.item_name = null
      this.form.description = null
    },
    openItemsPermissionModal(item) {
      this.selectItem = item

      this.form.site_permission = 'readable'

      const el = document.querySelector('#items-permission-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()
    },
    async onSetItemsPermission() {
      this.loading++

      const el = document.querySelector('#items-permission-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.hide()

      if (this.selectedItemIds.length > 0) {
        let success = 0

        for (let i = 0; i < this.selectedItemIds.length; i++) {
          const item = this.getSelectedItem(this.selectedItemIds[i])
          if (item) {
            const response = await this.updateItemPermission(this.currentSite.site_id, item.item_code, this.form)

            if (response.code === 0) {
              success++
            }
          }
        }

        if (this.selectedItemIds.length === success) {
          this.$notify({
            title: '成功',
            message: '已設定權限',
            type: 'success'
          })
        } else if (success > 0) {
          this.$notify({
            title: '設定部份權限',
            message: '未能設定全部權限',
            type: 'error'
          })
        } else {
          this.$notify({
            title: '未能設定權限',
            message: '系統錯誤，請稍後再試',
            type: 'error'
          })
        }

        this.selectedItemIds = []

        this.loadLibraryItems()
      }

      this.form.site_permission = null

      this.loading--
    },
    async loadUsers(resetCurrentPage = true) {
      const users = await this.getAllUsers()

      for (let i = 0; i < users.length; i++) {
        users[i].searchLabel = this.getUserSearchLabel(users[i])
      }

      this.users = users
    },
    async loadUserGroups() {
      this.userGroups = await this.getUserGroups(this.currentSite.site_id, '', 0, 1, true)
    },
    async openPermissionModal(item) {
      this.selectItem = item
      this.selectUser = null
      this.selectGroup = null
      this.shareFilteredUsers = null
      this.shareFilteredGroups = null
      this.userIds = []
      this.form.user_id = null
      this.userGroupIds = []
      this.form.group_id = null
      this.form.permission = ''

      if (this.selectItem === 0) {
        this.form.site_permission = this.currentSite.library_root_permission
      } else if (this.selectItem != null) {
        this.form.site_permission = this.selectItem.site_permission
      } else {
        this.form.site_permission = null
      }
      this.form.old_site_permission = this.form.site_permission

      const el = document.querySelector('#permission-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()

      await this.loadShareEnrollments(item)
    },
    async onSetPermission() {
      this.loading++

      const response = await this.updateItemPermission(this.currentSite.site_id, this.selectItem === 0 ? 0 : this.selectItem.item_code, this.form)

      this.form.old_site_permission = this.form.site_permission

      let option = {
        title: '成功',
        message: '已設定權限',
        type: 'success'
      }

      if (response.code === 0) {
        this.loadShareEnrollments(this.selectItem)
        if (this.selectItem === 0) {
          this.$root.$children[0].updateCurrentSiteData(this.currentSite.site_id)
        } else if (this.item != null && this.selectItem.item_id === this.item.item_id) {
          this.getItem()
        } else {
          this.loadLibraryItems()
        }
      } else {
        option = {
          title: '未能設定權限',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        }
      }

      this.$notify(option)

      this.loading--
    },
    async loadShareEnrollments(item, clearSearch = true) {
      this.loading++

      this.shareFilteredUsers = null
      this.shareFilteredGroups = null

      if (clearSearch) {
        this.selectedFolderPermission = ''
        this.searchFolderPermission = ''
      }

      this.shareUsers = await this.getLibraryItemShares(this.currentSite.site_id, this.selectItem === 0 ? 0 : item.item_code)

      this.userOptions = this.users.filter((x) => {
        for (let i = 0; i < this.shareUsers.length; i++) {
          if (!this.shareUsers[i].is_inherited && !this.shareUsers[i].group && this.shareUsers[i].user_id === x.user_id) {
            return false
          }
        }

        return true
      })

      this.shareGroups = await this.getLibraryItemShareGroups(this.currentSite.site_id, this.selectItem === 0 ? 0 : item.item_code)

      this.userGroupOptions = this.userGroups.filter((x) => {
        for (let i = 0; i < this.shareGroups.length; i++) {
          if (!this.shareGroups[i].is_inherited && this.shareGroups[i].group_id === x.group_id) {
            return false
          }
        }

        return true
      })

      this.onFilterShare()

      this.loading--
    },
    clickSearchFolderPermission() {
      this.onFilterShare()
    },
    onFilterShare() {
      if (this.selectedFolderPermission === '' && this.searchFolderPermission === '') {
        this.shareFilteredUsers = this.shareUsers
        this.shareFilteredGroups = this.shareGroups
        return
      }

      const val = this.searchFolderPermission.toLowerCase()
      this.shareFilteredUsers = this.shareUsers.filter((x) => {
        return (this.selectedFolderPermission === '' || this.selectedFolderPermission === x.permission) &&
          (val === '' || (x.user && (x.user.display_name?.toLowerCase().includes(val) || x.user.full_name?.toLowerCase().includes(val) || x.user.email?.toLowerCase().includes(val) || x.user.staff_number?.toLowerCase().includes(val) || (x.group?.display_name?.toLowerCase().includes(val)))))
      })

      this.shareFilteredGroups = this.shareGroups.filter((x) => {
        return (this.selectedFolderPermission === '' || this.selectedFolderPermission === x.permission) && (val === '' || (x.userGroup?.display_name?.toLowerCase().includes(val)))
      })
    },
    async onAddShare() {
      this.loading++

      let option = {
        title: '成功',
        message: this.shareType === 'user' ? '已分享給用戶' : '已分給用戶組別',
        type: 'success'
      }

      if (this.shareType === 'user') {
        for (let i = 0; i < this.userIds.length; i++) {
          this.form.user_id = this.userIds[i].user_id

          const response = await this.createLibraryItemShare(this.currentSite.site_id, this.selectItem === 0 ? 0 : this.selectItem.item_code, this.form)

          if (response.code === 0) {
            this.loadShareEnrollments(this.selectItem)
          } else {
            option = {
              title: '未能分享資料夾給用戶',
              message: response.data.message ?? '系統錯誤，請稍後再試',
              type: 'error'
            }
            break
          }
        }
      } else {
        for (let i = 0; i < this.userGroupIds.length; i++) {
          this.form.group_id = this.userGroupIds[i].group_id

          const response = await this.createLibraryItemShareGroup(this.currentSite.site_id, this.selectItem === 0 ? 0 : this.selectItem.item_code, this.form)

          if (response.code === 0) {
            this.loadShareEnrollments(this.selectItem)
          } else {
            option = {
              title: '未能分享資料夾給用戶組別',
              message: response.data.message ?? '系統錯誤，請稍後再試',
              type: 'error'
            }
            break
          }
        }
      }

      this.$notify(option)

      this.userIds = []
      this.form.user_id = null
      this.userGroupIds = []
      this.form.group_id = null
      this.form.permission = ''

      this.loading--
    },
    onStartUpdateShare(item) {
      this.selectUser = item
      this.form.permission = item.permission
    },
    onStartUpdateShareGroup(item) {
      this.selectGroup = item
      this.form.permission = item.permission
    },
    async onUpdateShare() {
      this.loading++

      if (this.shareType === 'user') {
        const response = await this.updateLibraryItemShare(this.currentSite.site_id, this.selectItem === 0 ? 0 : this.selectItem.item_code, this.selectUser.id, this.form)

        let option = {
          title: '成功',
          message: '已更改用戶分享權限',
          type: 'success'
        }

        if (response.code !== 0) {
          option = {
            title: '未能更改用戶分享權限',
            message: response.data.message ?? '系統錯誤，請稍後再試',
            type: 'error'
          }
        }

        this.$notify(option)

        this.selectUser = null
      } else {
        const response = await this.updateLibraryItemShareGroup(this.currentSite.site_id, this.selectItem === 0 ? 0 : this.selectItem.item_code, this.selectGroup.id, this.form)

        let option = {
          title: '成功',
          message: '已更改組別分享權限',
          type: 'success'
        }

        if (response.code !== 0) {
          option = {
            title: '未能更改組別分享權限',
            message: response.data.message ?? '系統錯誤，請稍後再試',
            type: 'error'
          }
        }

        this.$notify(option)

        this.selectGroup = null
      }

      this.loadShareEnrollments(this.selectItem)

      this.form.permission = ''

      this.loading--
    },
    openCopyPermissionShare() {
      const el = document.querySelector('#permission-share-copy-confirmation-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()
    },
    async onCopyPermissionShare() {
      this.loading++

      const response = await this.copyLibraryItemAllShare(this.currentSite.site_id, this.selectItem.item_code)

      let option = {
        title: '成功',
        message: '已複製權限的指定用戶／組別',
        type: 'success'
      }

      if (response.code !== 0) {
        option = {
          title: '未能複製權限的指定用戶／組別',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        }
      }

      this.$notify(option)

      this.loadShareEnrollments(this.selectItem)

      this.loading--
    },
    async onRemoveShare(item) {
      this.loading++

      const response = await this.deleteLibraryItemShare(this.currentSite.site_id, this.selectItem === 0 ? 0 : this.selectItem.item_code, item.id)

      let option = {
        title: '成功',
        message: '已移除用戶',
        type: 'success'
      }

      if (response.code !== 0) {
        option = {
          title: '未能移除用戶',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        }
      }

      this.$notify(option)

      this.loadShareEnrollments(this.selectItem)

      this.form.user_id = null
      this.form.permission = ''

      this.loading--
    },
    async onRemoveShareGroup(item) {
      this.loading++

      const response = await this.deleteLibraryItemShareGroup(this.currentSite.site_id, this.selectItem === 0 ? 0 : this.selectItem.item_code, item.id)

      let option = {
        title: '成功',
        message: '已移除組別',
        type: 'success'
      }

      if (response.code !== 0) {
        option = {
          title: '未能移除組別',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        }
      }

      this.$notify(option)

      this.loadShareEnrollments(this.selectItem)

      this.form.group_id = null
      this.form.permission = ''

      this.loading--
    },
    async onCreateShareCode(item) {
      this.loading++

      const response = await this.createLibraryItemShareCode(this.currentSite.site_id, item.item_code)
      if (response.code === 0) {
        this.onCopyShareLink(response.data)
      } else {
        const option = {
          title: '未能製作分享連結',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        }

        this.$notify(option)
      }

      this.loading--
    },
    onCopyShareLink(item) {
      if (item.item_type === 'FILE') {
        this.copyToClipboard(window.location.protocol + '//' + window.location.host + `/library/share/${item.share_code}`)
      } else {
        this.copyToClipboard(window.location.protocol + '//' + window.location.host + `/library/share-folder/${item.share_code}`)
      }

      const option = {
        title: '成功',
        message: '已複製分享連結',
        type: 'success'
      }

      this.$notify(option)
    },
    async openVersionModal(item) {
      this.loading++

      this.selectItem = item

      const el = document.querySelector('#version-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()

      await this.loadItemVersions(item)

      this.loading--
    },
    async loadItemVersions(item) {
      this.loading++

      this.itemVersions = null

      this.itemVersions = await this.getItemVersions(this.currentSite.site_id, item.item_code)

      this.loading--
    },
    async onUploadNewVersion(file) {
      if (file.size > 100000000) {
        this.$notify({
          title: '未能上載檔案',
          message: '檔案大小不能超過 100MB',
          type: 'error'
        })
        return
      }

      this.loading++

      const response = await this.createItemVersion(this.currentSite.site_id, this.selectItem.item_code, file)

      let option = {
        title: '成功',
        message: '已上載新版本',
        type: 'success'
      }

      if (response.code === 0) {
        await this.loadItemVersions(this.selectItem)
        this.loadLibraryItems()
      } else {
        option = {
          title: '未能上載新版本',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        }
      }

      this.$notify(option)

      this.loading--
    },
    async onChangeVersion(versionId) {
      const response = await this.changeItemVersion(this.currentSite.site_id, this.selectItem.item_code, {
        version_id: versionId
      })

      let option = {
        title: '成功',
        message: '已更改版本',
        type: 'success'
      }

      if (response.code === 0) {
        await this.loadItemVersions(this.selectItem)
        this.loadLibraryItems()
      } else {
        option = {
          title: '未能更改版本',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        }
      }

      this.$notify(option)
    },
    async loadTags() {
      this.loading++

      const response = await this.getLibraryTags()
      this.levelTags = []
      this.loadRecursiveTags(response, 0)

      this.loading--
    },
    loadRecursiveTags(tags, level) {
      for (let i = 0; i < tags.length; i++) {
        let space = ''
        for (let j = 0; j < level; j++) {
          space += '  '
        }
        tags[i].tag_name_with_level = space + tags[i].tag_name.trim()

        this.levelTags.push(tags[i])
        this.loadRecursiveTags(tags[i].children, level + 1)
      }
    },
    async openTagModal(item) {
      this.loading++

      this.selectItem = item
      this.itemTags = null

      const el = document.querySelector('#tag-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()

      if (item) {
        await this.loadLibraryItemTags(item)
      } else {
        this.tagOptions = this.levelTags
      }

      this.loading--
    },
    async loadLibraryItemTags(item) {
      this.loading++

      const response = await this.getLibraryItem(this.currentSite.site_id, item.item_code)
      this.itemTags = response.data.tags

      this.tagOptions = this.levelTags.filter((x) => {
        for (let i = 0; i < this.itemTags.length; i++) {
          if (this.itemTags[i].tag_id === x.tag_id) {
            return false
          }
        }

        return true
      })

      this.loading--
    },
    async onAddItemTags() {
      this.loading++

      if (this.selectedItemIds.length > 0) {
        let success = 0
        for (let i = 0; i < this.selectedItemIds.length; i++) {
          const item = this.getSelectedItem(this.selectedItemIds[i])
          if (item) {
            for (let i = 0; i < this.form.tags.length; i++) {
              const form = {
                tag_id: this.form.tags[i].tag_id
              }

              const response = await this.addLibraryItemTag(this.currentSite.site_id, item.item_code, form)

              if (response.code === 0) {
                success++
              }
            }
          }
        }
        if ((this.selectedItemIds.length * this.form.tags.length) === success) {
          this.$notify({
            title: '成功',
            message: '已新增標籤',
            type: 'success'
          })
        } else if (success > 0) {
          this.$notify({
            title: '新增部份標籤',
            message: '未能新增全部標籤',
            type: 'error'
          })
        } else {
          this.$notify({
            title: '未能新增標籤',
            message: '系統錯誤，請稍後再試',
            type: 'error'
          })
        }

        this.selectedItemIds = []
      } else {
        for (let i = 0; i < this.form.tags.length; i++) {
          const form = {
            tag_id: this.form.tags[i].tag_id
          }

          const response = await this.addLibraryItemTag(this.currentSite.site_id, this.selectItem.item_code, form)

          if (response.code !== 0) {
            const option = {
              title: `未能新增標籤：${this.form.tags[i].tag_name}`,
              message: response.data.message ?? '系統錯誤，請稍後再試',
              type: 'error'
            }

            this.$notify(option)
            return
          }
        }

        const option = {
          title: '成功',
          message: '已新增標籤',
          type: 'success'
        }

        this.loadLibraryItemTags(this.selectItem)

        this.$notify(option)
      }

      this.form.tags = []

      this.loading--
    },
    async onRemoveItemTag(item) {
      this.loading++

      const response = await this.removeLibraryItemTag(this.currentSite.site_id, this.selectItem.item_code, item)

      let option = {
        title: '成功',
        message: '已移除標籤',
        type: 'success'
      }

      if (response.code === 0) {
        this.loadLibraryItemTags(this.selectItem)
      } else {
        option = {
          title: '未能移除標籤',
          message: response.data.message ?? '系統錯誤，請稍後再試',
          type: 'error'
        }
      }

      this.$notify(option)

      this.form.user_id = null
      this.form.permission = ''

      this.loading--
    },
    openDeleteModal(item) {
      this.selectItem = item

      const el = document.querySelector('#delete-confirmation-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()
    },
    async onDelete() {
      this.loading++

      const el = document.querySelector('#delete-confirmation-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.hide()

      if (this.selectItem != null) {
        const response = await this.deleteLibraryItem(this.currentSite.site_id, this.selectItem.item_code)

        let option = {
          title: '成功',
          message: '檔案已被刪除',
          type: 'success'
        }

        if (response.code === 0) {
          this.loadLibraryItems()
        } else {
          option = {
            title: '未能刪除檔案',
            message: response.data.message ?? '系統錯誤，請稍後再試',
            type: 'error'
          }
        }

        this.$notify(option)
      } else if (this.selectedItemIds.length > 0) {
        let option = {
          title: '成功',
          message: '檔案已被刪除',
          type: 'success'
        }

        for (let i = 0; i < this.selectedItemIds.length; i++) {
          const item = this.getSelectedItem(this.selectedItemIds[i])
          if (item) {
            const response = await this.deleteLibraryItem(this.currentSite.site_id, item.item_code)

            if (response.code === 0) {
              console.log('Success')
            } else {
              option = {
                title: '未能刪除檔案',
                message: response.data.message ?? '系統錯誤，請稍後再試',
                type: 'error'
              }
              break
            }
          }
        }

        this.selectedItemIds = []

        this.$notify(option)
        this.loadLibraryItems()
      }

      this.loading--
    },
    onSelect(item) {
    },
    selectAllItems() {
      this.clearSelectedItems()
      for (let i = 0; i < this.items.length; i++) {
        this.selectedItemIds.push(this.items[i].item_id)
      }
    },
    clearSelectedItems() {
      this.selectedItemIds = []
    },
    getSelectedItem(itemId) {
      const index = this.items.findIndex(e => e.item_id === itemId)
      if (index > -1) {
        return this.items[index]
      }
      return null
    },
    checkAllSelectedItemsType(type) {
      for (let i = 0; i < this.selectedItemIds.length; i++) {
        const item = this.getSelectedItem(this.selectedItemIds[i])
        if (item && item.item_type !== type) {
          return false
        }
      }

      return true
    },
    checkAllSelectedItemsHavePermission(permission) {
      for (let i = 0; i < this.selectedItemIds.length; i++) {
        const item = this.getSelectedItem(this.selectedItemIds[i])

        if (item) {
          if (item.user_permission === 'restricted') {
            return false
          }

          switch (permission) {
            case 'read':
              switch (item.user_permission) {
                case 'full': continue
                case 'readable': continue
                case 'writable': continue
                default: return false
              }
            case 'write':
              switch (item.user_permission) {
                case 'full': continue
                case 'writable': continue
                default: return false
              }
            case 'delete':
              switch (item.user_permission) {
                case 'full': continue
                default: return false
              }
          }

          // if (item.site_permission === 'restricted') {
          //   return false
          // } else if (item.site_permission === '') {
          //   continue
          // }

          // switch (permission) {
          //   case 'read':
          //     switch (item.site_permission) {
          //       case 'full': continue
          //       case 'readable': continue
          //       default: return false
          //     }
          //   case 'write':
          //     switch (item.site_permission) {
          //       case 'full': continue
          //       case 'writable': continue
          //       default: return false
          //     }
          //   case 'delete':
          //     switch (item.site_permission) {
          //       case 'full': continue
          //       default: return false
          //     }
          // }
        }
      }

      return true
    },
    checkAllSelectedItemsAreOwner() {
      for (let i = 0; i < this.selectedItemIds.length; i++) {
        const item = this.getSelectedItem(this.selectedItemIds[i])

        if (item) {
          if (item.user_id !== this.profile.user_id) {
            return false
          }
        }
      }

      return true
    },
    checkAllSelectedItemsAreHidden(isHidden) {
      for (let i = 0; i < this.selectedItemIds.length; i++) {
        const item = this.getSelectedItem(this.selectedItemIds[i])

        if (item) {
          if (Boolean(item.is_hidden) !== isHidden) {
            return false
          }
        }
      }

      return true
    },
    async onMultipleDownload() {
      for (let i = 0; i < this.selectedItemIds.length; i++) {
        const item = this.getSelectedItem(this.selectedItemIds[i])
        if (item) {
          await this.onDownload(item, item.item_name)
        }
      }

      this.selectedItemIds = []
    },
    checkModalFilter(item) {
      if (item.file != null && item.file.format && item.file.format.mime_type) {
        for (let i = 0; i < this.modalFilter.length; i++) {
          if (item.file.format.mime_type.startsWith(this.modalFilter[i])) {
            return true
          }
        }
      }
      return false
    },
    openMoveModal(item) {
      this.selectItem = item

      this.$refs.folderSelector.onShow(this.item ? this.item.item_code : '', item)
    },
    openUserGroupUsersViewerModal(group) {
      this.$refs.userGroupUsersViewer.onShow(group ? group.group_id : '')
    },
    async onSelectFolder(folder) {
      if (this.selectedItemIds.length > 0) {
        let success = 0
        for (let i = 0; i < this.selectedItemIds.length; i++) {
          const item = this.getSelectedItem(this.selectedItemIds[i])
          if (item) {
            const response = await this.moveLibraryItem(this.currentSite.site_id, item.item_code, {
              folder_id: folder ? folder.item_id : 0
            })

            if (response.code === 0) {
              success++
            }
          }
        }
        if (this.selectedItemIds.length === success) {
          this.$notify({
            title: '成功',
            message: '已移動',
            type: 'success'
          })
        } else if (success > 0) {
          this.$notify({
            title: '部份移動',
            message: '未能移動全部項目',
            type: 'error'
          })
        } else {
          this.$notify({
            title: '未能移動',
            message: '系統錯誤，請稍後再試',
            type: 'error'
          })
        }

        this.selectedItemIds = []
      } else {
        const response = await this.moveLibraryItem(this.currentSite.site_id, this.selectItem.item_code, {
          folder_id: folder ? folder.item_id : 0
        })

        let option = {
          title: '成功',
          message: '已移動',
          type: 'success'
        }

        if (response.code === 0) {
          if (this.item != null && this.selectItem.item_id === this.item.item_id) {
            this.getItem()
          }
        } else {
          option = {
            title: '未能移動',
            message: response.data.message ?? '系統錯誤，請稍後再試',
            type: 'error'
          }
        }

        this.$notify(option)
      }
      this.loadLibraryItems()
    },
    goToProfile(userId) {
      if (this.checkPermission(this.permissions, 'system.user.view')) {
        setTimeout(() => {
          const el = document.querySelector('#permission-modal')
          const modal = window.tailwind.Modal.getOrCreateInstance(el)
          modal.hide()
        }, 100)

        setTimeout(() => {
          this.$router.push(`/users/${userId}`)
        }, 200)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#library-page {

  &.page {
    margin-bottom: 600px;
  }

  .directory-list {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */

    .root {
      flex: 0 0 56px;
    }

    > span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      a,
      button {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    > div {
      white-space: nowrap;
    }
  }

  .directory-list::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
  }

  table {
    tr {
      &:hover {
        td {
          background-color: rgb(var(--color-primary) / 0.3);
        }
      }

      th {
        padding-left: 4px;
        padding-right: 4px;
      }
      td {
        padding: 6px 4px 6px 4px;
        cursor: pointer;
      }

      th.text-center button.flex {
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  .item-icon {
    display: block;
    width: 26px;
    height: 26px;
    margin-left: auto;
    margin-right: auto;
  }

  .bg-contain {
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .folder {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='786' height='786' viewBox='0 0 786 786'%3E%3Cdefs%3E%3ClinearGradient id='linear-gradient' x1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%238a97ac'/%3E%3Cstop offset='1' stop-color='%235d6c83'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg id='Group_3' data-name='Group 3' transform='translate(-567 -93)'%3E%3Crect id='Rectangle_4' data-name='Rectangle 4' width='418' height='681' rx='40' transform='translate(896 109)' fill='%2395a5b9'/%3E%3Crect id='Rectangle_3' data-name='Rectangle 3' width='433' height='681' rx='40' transform='translate(606 93)' fill='%23a0aec0'/%3E%3Crect id='Rectangle_2' data-name='Rectangle 2' width='742' height='734' rx='40' transform='translate(590 145)' fill='%23bec8d9'/%3E%3Crect id='Rectangle_5' data-name='Rectangle 5' width='786' height='692' rx='40' transform='translate(567 187)' fill='url(%23linear-gradient)'/%3E%3C/g%3E%3C/svg%3E%0A");
  }

  .file {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='628.027' height='786.012' viewBox='0 0 628.027 786.012'%3E%3Cdefs%3E%3ClinearGradient id='linear-gradient' x1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%238a97ac'/%3E%3Cstop offset='1' stop-color='%235d6c83'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg id='Group_5' data-name='Group 5' transform='translate(-646 -92.988)'%3E%3Cpath id='Union_2' data-name='Union 2' d='M40,786A40,40,0,0,1,0,746V40A40,40,0,0,1,40,0H501V103h29v24h98V746a40,40,0,0,1-40,40Z' transform='translate(646 93)' fill='url(%23linear-gradient)'/%3E%3Cpath id='Intersection_2' data-name='Intersection 2' d='M.409,162.042l.058-109.9c31.605,29.739,125.37,125.377,125.37,125.377l-109.976.049A20.025,20.025,0,0,1,.409,162.042Z' transform='translate(1147 42)' fill='%23bec8d9' stroke='%23bec8d9' stroke-width='1'/%3E%3C/g%3E%3C/svg%3E%0A");

    span {
      color: #fff;
      font-size: 8px;
      text-decoration: none;
    }
  }

  .invisible td:not(.column-item-icon):not(.table-report__action) {
    text-decoration: line-through;
  }
  .invisible-from-parent:not(.invisible) td:not(.column-item-icon):not(.table-report__action) {
    text-decoration: line-through dashed #666666;
  }

  .action {
    .show {
      visibility: visible;
      opacity: 1;
    }

    .dropdown-menu {
      margin-top: 10px;
      left: -100px;

      button {
        width: 100%;
      }
    }
  }

  /* .folder-action {
    .dropdown-menu {
      left: auto;
      right: -10px;
    }
  } */
}

#tag-modal {
  .modal-dialog .modal-content .modal-body {
    .multiselect {
      ::v-deep .multiselect__content-wrapper ul li {
        span {
          white-space: pre-wrap;
        }
      }
    }
  }
}

#tag-filter {
  option {
    white-space: pre-wrap;
  }
}
</style>
